(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    // Instant feedback for the rich dropdown: the closed face and the price
  // block update from data already in the DOM the moment a choice is made.
  // The theme's fetch-and-morph still runs and lands with identical values,
  // so this only removes the round-trip wait, never diverges from it.
  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement)) return;
    if (!select.classList.contains('variant-option__select')) return;

    const option = select.options[select.selectedIndex];
    if (!option) return;

    // Face rebuild works from option.value with the same dash-split as the
    // Liquid, so it behaves identically in browsers that strip the spans
    // inside <option> (Safari, Firefox) and those that keep them.
    const wrapper = select.closest('.variant-option__select-wrapper--rich');
    const face = wrapper && wrapper.querySelector('.variant-option__selected-face');
    if (face) {
      // Trimmed to match the Liquid sites' `| strip`; without it a padded
      // value splits differently here than in the server render this mirrors.
      const value = option.value.trim();
      let namePart = value;
      let detailPart = '';
      let parenPart = '';
      // Mirrors tk_spaced_delims / tk_glued_delims above, digit guard included.
      const split = (forms, guard) => {
        for (const delim of forms) {
          const at = value.indexOf(delim);
          if (at < 0) continue;
          if (guard && (at === 0 || /[0-9]/.test(value[at - 1]))) continue;
          namePart = value.slice(0, at);
          detailPart = value.slice(at + delim.length);
          return true;
        }
        return false;
      };
      split([' – ', ' — ', ' - '], false) || split(['– ', '— ', '- ', ' –', ' —', ' -'], true);
      const parenAt = detailPart.indexOf(' (');
      if (parenAt > -1) {
        parenPart = detailPart.slice(parenAt + 1);
        detailPart = detailPart.slice(0, parenAt);
      }
      face.textContent = '';
      const name = document.createElement('span');
      name.className = 'variant-option__selected-face__name';
      name.textContent = namePart;
      face.appendChild(name);
      if (detailPart) {
        const detail = document.createElement('span');
        detail.className = 'variant-option__selected-face__detail';
        detail.textContent = detailPart;
        if (parenPart) {
          const paren = document.createElement('span');
          paren.className = 'variant-option__selected-face__paren';
          paren.textContent = parenPart;
          detail.appendChild(document.createTextNode(' '));
          detail.appendChild(paren);
        }
        face.appendChild(detail);
      }
    }

    // Price swap covers the simple non-sale layout only; sale layouts wait
    // for the authoritative server render. Products with several option
    // groups are also skipped: each group's stamps assume the other groups'
    // selections as of the last render, so rapid changes across groups could
    // flash a stale combination's price.
    const priceText = option.dataset.tkPrice;
    if (!priceText || option.dataset.tkSale) return;
    const picker = select.closest('variant-picker');
    const productId = picker && picker.dataset.productId;
    if (!productId) return;
    if (picker.querySelectorAll('select.variant-option__select').length !== 1) return;
    if (picker.querySelector('fieldset')) return;
    const scope = select.closest('.shopify-section, dialog') || document;
    for (const pp of scope.querySelectorAll(`product-price[data-product-id="${productId}"]`)) {
      const regular = pp.querySelector('.price__regular:not(.price__hidden)');
      if (!regular) continue;
      const priceEl = regular.querySelector('.price');
      if (priceEl) {
        let star = priceEl.querySelector('.approx-label');
        priceEl.textContent = priceText;
        if (option.dataset.tkApprox) {
          if (!star) {
            star = document.createElement('span');
            star.className = 'approx-label';
            star.setAttribute('aria-hidden', 'true');
            star.textContent = '*';
          }
          priceEl.prepend(star);
        }
      }
      const unitEl = pp.querySelector('.unit-price');
      if (unitEl) unitEl.textContent = option.dataset.tkUnit || '';
    }
  });
  } catch(e) { console.error(e); }
})();

})();
